export const isLogin = function () {
    const token = localStorage.getItem('bsKy');
    return !!token;
};


export const getUserId = () => {
    return localStorage.getItem('bsKy')
}